(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
//Initalize Hero Slider 
  $('.hero-slideshow').slick({
    arrows: false,
    appendDots: $('.hero .hero-controls .dots'),
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-carousel"] && !Shopify.designMode) return;
  try {
    
var homepageCarouselSlider = $('.homepage-carousel .room-carousel');

//Initalize Hero Slider 
  homepageCarouselSlider.slick({
    arrows: false,
    dots: true,
    appendDots: $('.homepage-carousel .hero-controls .dots'),
    infinite: true,
    autoplay: false,
    slidesToShow: 1
  });

  //Go to Slide
  $('.homepage-carousel .room-carousel-nav li').click(function(){
    homepageCarouselSlider.slick('slickGoTo',($(this).data('index')));
  });

  //Remove and Add Active to Nav Link
  $('.homepage-carousel .room-carousel').on('beforeChange', function(event, slick, currentSlide){
    $('.homepage-carousel .room-carousel-nav li').removeClass('active');
  });

  $('.homepage-carousel .room-carousel').on('afterChange', function(event, slick, currentSlide){
    $('.homepage-carousel .room-carousel-nav li[data-index="'+currentSlide+'"]').addClass('active');
  });

  } catch(e) { console.error(e); }
})();
})();
